import { Row, Col, Button, Typography, Divider } from "antd";
import { CloseOutlined, PrinterFilled } from "@ant-design/icons";
import moment from "moment";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";

const PayrollPrint = ({ payrollList, close }) => {
  const printRef = useRef();
  const calculateLateUnder = (late, under, per_mins) => {
    var total = 0;
    var totalLateUnder = parseFloat(late) + parseFloat(under);
    total = totalLateUnder * parseFloat(per_mins);
    return total;
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Payroll Report",
    pageStyle: `
      
      body {
        font-family: Arial, sans-serif;
      }
    `,
    // @page {
    //   size: A4 landscape;
    //   margin: 10mm;
    // }
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        // border: "1px solid red",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
          //   border: "1px solid red",
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Typography style={{ fontWeight: 500, fontSize: 16 }}>
            Payroll Print
          </Typography>{" "}
        </div>
        <Button
          type="dashed"
          icon={<PrinterFilled />}
          onClick={handlePrint}
          style={{ marginRight: 5 }}
        >
          Print
        </Button>
        <Button type="dashed" icon={<CloseOutlined />} onClick={close}>
          Close
        </Button>
      </div>
      <div
        className="print-container"
        style={{
          width: "100%",
          maxWidth: 1122,
          margin: "0 auto",
        }}
        ref={printRef}
      >
        {payrollList.ready &&
          payrollList.data.length > 0 &&
          Array.from(
            { length: Math.ceil(payrollList.data.length / 12) },
            (_, pageIndex) => (
              <div key={pageIndex} className="print-page">
                <Row gutter={[4, 4]}>
                  {payrollList.data
                    .slice(pageIndex * 12, pageIndex * 12 + 12)
                    .map((data, index) => (
                      <Col xs={6} key={index}>
                        <div
                          style={{
                            border: "1px solid #e5e5e5",
                            borderRadius: 5,
                          }}
                        >
                          <div style={{ padding: 5 }}>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                              }}
                            >
                              <div style={{ width: "33%" }}>
                                <Typography style={{ fontSize: 8 }}>
                                  Pay Period
                                </Typography>
                              </div>
                              <div style={{ width: "67%" }}>
                                <Typography style={{ fontSize: 8 }}>
                                  {moment
                                    .utc(new Date(data.date_from))
                                    .format("MMM DD")}{" "}
                                  -{" "}
                                  {moment
                                    .utc(new Date(data.date_to))
                                    .format("MMM DD, YYYY")}
                                </Typography>
                              </div>
                            </div>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                borderTop: "1px solid #e5e5e5",
                              }}
                            >
                              <div style={{ width: "33%" }}>
                                <Typography style={{ fontSize: 8 }}>
                                  Employee Name
                                </Typography>
                              </div>
                              <div style={{ width: "67%" }}>
                                <Typography style={{ fontSize: 8 }}>
                                  {data.employeedetails.lastname},{" "}
                                  {data.employeedetails.firstname}
                                </Typography>
                              </div>
                            </div>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                borderTop: "1px solid #e5e5e5",
                              }}
                            >
                              <div style={{ width: "33%" }}>
                                <Typography style={{ fontSize: 8 }}>
                                  Position
                                </Typography>
                              </div>
                              <div style={{ width: "67%" }}>
                                <Typography style={{ fontSize: 8 }}>
                                  {
                                    data.employeedetails
                                      .merchantemployeeposition.position
                                  }
                                </Typography>
                              </div>
                            </div>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                borderTop: "1px solid #e5e5e5",
                              }}
                            >
                              <div style={{ width: "33%" }}>
                                <Typography style={{ fontSize: 8 }}>
                                  Rate
                                </Typography>
                              </div>
                              <div style={{ width: "33%" }}>
                                <Typography
                                  style={{ fontSize: 8, textAlign: "right" }}
                                >
                                  {parseFloat(
                                    data.employeedetails.daily_amount
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Typography>
                              </div>
                              <div style={{ width: "34%" }} />
                            </div>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                borderTop: "1px solid #e5e5e5",
                              }}
                            >
                              <div style={{ width: "33%" }}>
                                <Typography style={{ fontSize: 8 }}>
                                  Basic Pay
                                </Typography>
                              </div>
                              <div style={{ width: "33%" }}>
                                <Typography
                                  style={{ fontSize: 8, textAlign: "right" }}
                                >
                                  {data.present_count}
                                </Typography>
                              </div>
                              <div style={{ width: "34%" }}>
                                <Typography
                                  style={{ fontSize: 8, textAlign: "right" }}
                                >
                                  {parseFloat(data.salary).toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}
                                </Typography>
                              </div>
                            </div>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                borderTop: "1px solid #e5e5e5",
                              }}
                            >
                              <div style={{ width: "50%" }}>
                                <Typography style={{ fontSize: 8 }}>
                                  Reg.OT
                                </Typography>
                              </div>
                              <div style={{ width: "50%" }}>
                                <Typography
                                  style={{ fontSize: 8, textAlign: "right" }}
                                >
                                  {parseFloat(
                                    data.total_overtime !== null
                                      ? data.total_overtime
                                      : 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Typography>
                              </div>
                            </div>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                borderTop: "1px solid #e5e5e5",
                              }}
                            >
                              <div style={{ width: "50%" }}>
                                <Typography style={{ fontSize: 8 }}>
                                  Late/Undertime
                                </Typography>
                              </div>
                              <div style={{ width: "50%" }}>
                                <Typography
                                  style={{ fontSize: 8, textAlign: "right" }}
                                >
                                  {parseFloat(
                                    (parseFloat(data.late_mins) +
                                      parseFloat(data.under_mins)) *
                                      parseFloat(data.per_mins)
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Typography>
                              </div>
                            </div>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                borderTop: "1px solid #e5e5e5",
                              }}
                            >
                              <div style={{ width: "66%" }}>
                                <Typography
                                  style={{
                                    fontSize: 8,
                                    textAlign: "center",
                                    fontWeight: "bold",
                                  }}
                                >
                                  GROSS PAY
                                </Typography>
                              </div>
                              <div style={{ width: "34%" }}>
                                <Typography
                                  style={{
                                    fontSize: 8,
                                    textAlign: "right",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {parseFloat(
                                    parseFloat(data.salary) +
                                      parseFloat(
                                        data.total_overtime !== null
                                          ? data.total_overtime
                                          : 0
                                      ) -
                                      (parseFloat(data.late_mins) +
                                        parseFloat(data.under_mins)) *
                                        parseFloat(data.per_mins)
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Typography>
                              </div>
                            </div>
                            {data.employeedeductions.length > 0 && (
                              <>
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    borderTop: "1px solid #e5e5e5",
                                  }}
                                >
                                  <div style={{ width: "100%" }}>
                                    <Typography
                                      style={{
                                        fontSize: 8,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      DEDUCTIONS:
                                    </Typography>
                                  </div>
                                </div>
                                {data.employeedeductions.map((item, index2) => (
                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      borderTop: "1px solid #e5e5e5",
                                    }}
                                    key={index2}
                                  >
                                    <div style={{ width: "66%" }}>
                                      <Typography
                                        style={{
                                          fontSize: 8,
                                        }}
                                      >
                                        {item.description}
                                      </Typography>
                                    </div>
                                    <div style={{ width: "34%" }}>
                                      <Typography
                                        style={{
                                          fontSize: 8,
                                          textAlign: "right",
                                        }}
                                      >
                                        {parseFloat(item.amount).toLocaleString(
                                          undefined,
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }
                                        )}
                                      </Typography>
                                    </div>
                                  </div>
                                ))}
                              </>
                            )}
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                borderTop: "1px solid #e5e5e5",
                              }}
                            >
                              <div style={{ width: "66%" }}>
                                <Typography
                                  style={{
                                    fontSize: 8,
                                    textAlign: "center",
                                    fontWeight: "bold",
                                  }}
                                >
                                  NET PAY
                                </Typography>
                              </div>
                              <div style={{ width: "34%" }}>
                                <Typography
                                  style={{
                                    fontSize: 8,
                                    textAlign: "right",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {parseFloat(data.gross_salary).toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}
                                </Typography>
                              </div>
                            </div>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                borderTop: "1px solid #e5e5e5",
                              }}
                            >
                              <div style={{ width: "100%" }}>
                                <Typography style={{ fontSize: 8 }}>
                                  I acknowledge to have received the amount of{" "}
                                  <span style={{ fontWeight: "bold" }}>
                                    {parseFloat(
                                      data.gross_salary
                                    ).toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </span>{" "}
                                  and have no further claim for services
                                  rendered.
                                </Typography>
                              </div>
                            </div>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderTop: "1px solid #e5e5e5",
                              }}
                            >
                              <div style={{ width: "33%" }}>
                                <Typography style={{ fontSize: 8 }}>
                                  Date: ______________
                                </Typography>
                              </div>
                              <div
                                style={{
                                  width: "67%",
                                }}
                              >
                                <div>
                                  <Typography
                                    style={{
                                      fontSize: 8,
                                      textAlign: "center",
                                      borderBottom: "1px solid #e5e5e5",
                                    }}
                                  >
                                    {data.employeedetails.lastname},{" "}
                                    {data.employeedetails.firstname}
                                  </Typography>
                                  <Typography
                                    style={{ fontSize: 8, textAlign: "center" }}
                                  >
                                    {
                                      data.employeedetails
                                        .merchantemployeeposition.position
                                    }
                                  </Typography>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    ))}
                </Row>
              </div>
            )
          )}
      </div>
    </div>
  );
};

export default PayrollPrint;
